import React from "react";
import { AdSenseUnit, AD_SLOTS } from "./AdSenseUnit";

// Sticky banner fixed at the bottom of the viewport (overlay). Stays in the lower
// part of the screen while scrolling. Slot: "Banner basso".
export const StickyBottomBanner = () => {
  return (
    <div
      data-testid="sticky-bottom-ad"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 shadow-[0_-4px_20px_rgba(15,23,42,0.06)] backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-[970px] flex-col items-center px-2 py-1">
        <span className="text-[9px] font-medium uppercase tracking-wider text-slate-400">
          Annuncio
        </span>
        <div className="flex h-[90px] w-full items-center justify-center overflow-hidden">
          <AdSenseUnit
            testId="sticky-bottom-ad-unit"
            slot={AD_SLOTS.stickyBottom}
            style={{ display: "inline-block", width: 728, height: 90 }}
          />
        </div>
      </div>
    </div>
  );
};
